import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import Numeral from 'numeral'

import { getProject, fetchProject, downloadProposal, fetchProposal, getProposal, selectProposal, downloadCourseSyllabus, askRevisionProposal } from '../../../store/client'
import { getUser} from '../../../store/alpha'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import DetailViewController from '../../../shared/ui/DetailViewController'
import Button from '../../../shared/ui/Button'
import Link from '../../../shared/ui/Link'
import { capitalize, secondsToTime } from '../../../shared/utilities/helpers'
import AttachmentListView from '../../../shared/ui/AttachmentListView'
import InfoSection from '../../../shared/ui/InfoSection'
import TableData from '../../../shared/ui/TableData'
import Section from '../../../shared/ui/Section'
import InputField from '../../../shared/ui/InputField'
import DialogBox from '../../../shared/ui/DialogBox'
import DateCard from '../../../shared/ui/DateCard'
import StatusLabel from '../../../shared/ui/StatusLabel'

import ProposalSelectForm from '../views/ProposalSelectForm'
import RequestRevisionForm from '../views/RequestRevisionForm'

import Typography from '@material-ui/core/Typography'
import BackIcon from '@material-ui/icons/ArrowBackIos'
import BusinessIcon from '@material-ui/icons/Business'

import Box from '@material-ui/core/Box'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
  },
})

const ProposalDetailController = ({ theme, classes, ...props }) => {
  const { proposalKey, orderKey, isFetching, lastFetched, data, user, project, askRevisionProposal, selectProposal, downloadCourseSyllabus, fetchProposal, downloadProposal, fetchProject } = props
  
  const navigationContext = useContext(NavigationContext)
  const [openRevision, setOpenRevision] = React.useState(false);
  const [openAgreement, setOpenAgreement] = React.useState(false);

  const ProposalStatusColor = {
    'Draft': '#ffaa00',
    'Submitted': '#0000cc',
    'Ordered': '#000000',
    'Canceled': '#aaaaaa',
  }

  useEffect(() => {
    fetchProject(true)
    fetchProposal()
  }, [])  

  let columns = [
    { key: 'course_name', label: 'Course Detail', variant: 'title' },
    { key: 'trainer_name', label: 'Trainer'},
    { key: 'training_date', label: 'Date & Venue' },
    { key: 'participant_count', label: 'Quantity' },
    { key: 'price', label: 'Price/pax', type: 'currency' },    
    { key: 'total', label: 'Total', type: 'currency' },
  ]
  
  if (lastFetched && data.training_classes.find(t =>
      t.delivery_method === 'offline' && t.venue && !t.venue.in_house))
    columns.splice(5, 0, 
      { key: 'venue_price', label: 'Venue/pax', type: 'currency' },
    )

  const getCellValue = (row, column, rowIndex, columnIndex) => {
    if (column.key == 'course_name') {
      return row.course.name      
    } else if (column.key == 'training_date') {
      return (
        <Typography variant='body1'>
          {moment(row.training_date).format('DD MMM YYYY')} ({row.training_days > 1 ? row.training_days+' days)' : row.training_days+' day)'}
        </Typography>
      )
    } else if (column.key == 'participant_count') {
        return row[column.key] + ' pax'           
    } else if (column.key == 'trainer_name') {
        return (
          <Link to={row['trainer'] ? '/trainer/'+ row['trainer'].uid : null} target='_blank'>
            <Typography>
              {row['trainer'] ? row['trainer'].first_name + ' ' +row['trainer'].last_name : ''}
            </Typography>
          </Link>
        )

    } else if (column.key == 'price') {
        return row['price_per_participant'] + ' /pax'
    } else if (column.key == 'venue_price') {
        return row['venue_price_per_participant'] + ' /pax'
    }
  
    return row[column.key]
  }

  const getCellSecondaryValue = (row, column) => {
    if (column.key == 'training_date')
      return (
        <>        
          { row.delivery_method !== 'online' ?
            <Typography variant='body1'>
              {row.venue &&
              <>
              <Typography variant='body1'>
                  Location: {row.venue ? row.venue.state : '-'} {row.venue.line4 ? '- '+row.venue.line4 : '' }
              </Typography>
              <Typography>
                  Venue:  {row.venue && row.venue.in_house ? 'In House' : 'Arranged By PasarTrainer'}
              </Typography>
              </>
              }
            </Typography>
            :
            <>
              {capitalize(row.delivery_method)} via {row.delivery_app || 'Zoom'}
            </>
          }
        </>
    )
    else if (column.key == 'course_name')
      return (
        <Button onClick={() => {
          navigationContext.showLoadingDialog(true)
          downloadCourseSyllabus(row.course.uid, () => navigationContext.showLoadingDialog(false))
        }}>
          Download Syllabus
        </Button>
      )
    // if (column.key == 'line_items')
    //     return moment(row.training_date).format('DD MMM YYYY') + ', ' + row.participant_count +' pax'
  }
  
  const backButton = (
    <Button icon={BackIcon} onClick={() => navigationContext.openLink("/company/order/view/"+orderKey)}>
      Project Detail
    </Button>
  )

  const handleRevision = (value) => {
    askRevisionProposal({ revision_detail: JSON.stringify(value) }, () => {
      navigationContext.showLoadingDialog(false)
      navigationContext.showMessageDialog(true)
      navigationContext.setMessageDialog(
        {
          title:'Cool!', 
          description:'Your revision request has been sent! Please wait for the training provider to respond to your revision request.'
        }
      )
      setOpenRevision(false)
      navigationContext.openLink("/company/order/view/"+orderKey)
    })
  }

  const handleSelectProposal = () => {
    selectProposal(() => {
      navigationContext.showLoadingDialog(false)
      navigationContext.showMessageDialog(true)
      navigationContext.setMessageDialog(
        {
          title:'Cool!', 
          description:'You have completed the order process! Now your class is ready to deliver. The training provider and us will ensure everything is ready for the training day.'
        }
      )
      navigationContext.openLink("/company/order/view/"+orderKey)
      setOpenAgreement(false)
    })
  }

  const onDownload = () => {
    navigationContext.showLoadingDialog(true)
    downloadProposal(() => {
      navigationContext.showLoadingDialog(false)
    })
  } 

  let infoItems = []
  let reviseItems = []
  if (lastFetched) {
    infoItems.push({ label: 'Project No', value: data.project.project_no || '-' })
    infoItems.push({ label: 'Proposal No', value: data.proposal_no || '-' })
    infoItems.push({ label: 'From', value: 
      <Box display='flex'>
        <BusinessIcon style={{ marginRight:4 }}/>
        <Typography>
        { data.provider.name || '-' }  
        </Typography>         
      </Box>
    })
    infoItems.push({ label: 'Proposal Date', value: data.submitted_at ? <DateCard item={ data.submitted_at }/> : '-' })
    
    let status = 'Draft'
    if (data.canceled_at)
        status = 'Canceled'
    else if (data.submitted_at && !data.selected_at)
      status = 'Submitted'
    else if (data.selected_at)
      status = 'Ordered'
      
    infoItems.push({ label: 'Status', value: 
        <StatusLabel color={ProposalStatusColor[status] || '#555'}>
        { status }
        </StatusLabel>
      })

    reviseItems.push({ label: 'From', value: 
      <Box display='flex'>
        <BusinessIcon style={{ marginRight:4 }}/>
        <Typography>
        { data.provider.name || '-' }  
        </Typography>         
      </Box>
    })
    
    let revision = []
    if (data.revise_request_detail && data.revise_request_detail.startsWith('{')){
      revision = JSON.parse(data.revise_request_detail)

      reviseItems.push(
        { 
          label: 'Revision Request', 
          // value: data.revise_requested_at ? <DateCard item={ data.revise_requested_at } time={moment(data.revise_requested_at).format('hh:mm')} /> : '-'
          value: data.revise_requested_at ? moment(data.revise_requested_at).format('DD MMM YYYY hh:mm') : '-'
        }
      )

      if (revision.revision_detail) {
        let revisionDetail = Object.keys(revision.revision_detail).filter(k => revision.revision_detail[k])
        reviseItems.push(
          { 
            label: 'Revison Detail', 
            value: revisionDetail.length > 0 ? capitalize(revisionDetail.join(", ").replace('_',' ')) : ''
          }
        )
      }
      reviseItems.push({ label: 'Notes', value: revision.notes || ''})
    }
  }

  let actionButtons = lastFetched && data.submitted_at && !data.canceled_at ? [
      <Button 
        onClick={onDownload}
        >
        Download
      </Button>
    ] : []

  if (lastFetched && data.submitted_at && !data.selected_at && !data.canceled_at && !data.revise_requested_at)
    actionButtons.push(
      <Button variant='contained' onClick={() => setOpenAgreement(true)}>
        Order
      </Button>
    )

  if (lastFetched && data.submitted_at && !data.selected_at && !data.canceled_at && !data.revise_requested_at)
    actionButtons.push(
      <Button variant='contained' color='default' onClick={() => setOpenRevision(true)}>
        Ask Revision
      </Button>
    )

  return (
    <DetailViewController
      title={"Proposal"}
      isFetching={isFetching}
      lastFetched={lastFetched}
      backButton={backButton}
      actionButtons={actionButtons}  
      >
        { lastFetched &&
        <>

          { data.revise_requested_at &&
            <InfoSection items={reviseItems} color='#ffeb3b' gutterBottom />
          }

          <InfoSection items={infoItems} gutterBottom />
          <Section title='Items' gutterBottom>
            <TableData
                columns={columns}
                lastFetched={lastFetched}      
                isFetching={isFetching}
                rows={data.training_classes}
                getCellValue={getCellValue}
                getCellSecondaryValue={getCellSecondaryValue}
                >
            </TableData>
          </Section>

          <Section title='Notes & Attachments' gutterBottom>
            <Section title='Notes' variant='subsection' gutterBottom>
              <Box mb={3}>
                <Typography variant='body1'>
                    {data.notes}
                </Typography>
              </Box>
            </Section>
            <Section title='Attachments' variant='subsection' gutterBottom>
              <Box>
                <AttachmentListView
                  edit={false}
                  initialData={lastFetched ? data : {}}
                  formData={{}}
                  name={'attachments'}
                />
              </Box>
            </Section>
          </Section>

          { openRevision &&
            <RequestRevisionForm onClose={() => setOpenRevision(false)} onConfirm={handleRevision} />
          }

          { openAgreement &&
            <ProposalSelectForm onClose={() => setOpenAgreement(false)} onConfirm={handleSelectProposal}/>
          }
        </>
        }
    </DetailViewController>
  )
}

const mapStateToProps = (state, ownProps) => {
  let proposalKey = ownProps.match.params.proposalKey
  let orderKey = ownProps.match.params.orderKey
    
  return {
    proposalKey,
    orderKey,
    ...getProposal(state, proposalKey),
    project: getProject(state, orderKey),
    user: getUser(state)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  let proposalKey = ownProps.match.params.proposalKey
  let orderKey = ownProps.match.params.orderKey

  return {
    fetchProject: (refresh) => {
      dispatch(fetchProject(orderKey, true))
    },
    fetchProposal: () => {
        dispatch(fetchProposal(proposalKey,true))
    },
    downloadProposal: (onComplete) => {
      dispatch(downloadProposal(proposalKey, onComplete))
    },
    downloadCourseSyllabus:(courseKey, onComplete) =>{
      dispatch(downloadCourseSyllabus(courseKey, onComplete))
    },
    askRevisionProposal: (data, onComplete) => {
      dispatch(askRevisionProposal(proposalKey, data, onComplete))
    },
    selectProposal: (onComplete) => {
      dispatch(selectProposal(orderKey, proposalKey, onComplete))
    },
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(ProposalDetailController)
)
